import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet-async';
import ReactRecaptcha from 'react-recaptcha';

const Recaptcha = React.forwardRef((props, ref) => (
  <Fragment>
    <Helmet>
      <script async defer src="https://www.google.com/recaptcha/api.js" />
    </Helmet>
    <ReactRecaptcha ref={ref} {...props} />
  </Fragment>
));

export default Recaptcha;
